
import { Handle, Position } from '@xyflow/react';
import { ArrowRight } from 'lucide-react';
import { WorkflowNodeData } from './types';

// Define the props directly in this component to avoid type issues
interface CustomNodeProps {
  data: WorkflowNodeData;
  isConnectable?: boolean;
}

const CustomNode = ({ data, isConnectable = true }: CustomNodeProps) => {
  return (
    <div className="bg-white p-3 rounded-lg shadow-md border border-muted w-60">
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 rounded-full bg-neutral-300 border-2 border-white left-[-7px]"
      />
      <div className="flex items-center gap-2 mb-2">
        <div className="p-1.5 rounded-md bg-primary/10">
          {data.icon}
        </div>
        <div className="font-medium">{data.label}</div>
      </div>
      <div className="text-xs text-muted-foreground mb-1">{data.description}</div>
      <div className="mt-2 flex justify-end">
        <ArrowRight className="h-3 w-3 text-muted-foreground" />
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 rounded-full bg-primary border-2 border-white right-[-7px]"
      />
    </div>
  );
};

export default CustomNode;
